import { ElementRef, Injectable } from '@angular/core';
import { geojson } from '@lib/geojson';
import Map from 'ol/Map';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { TooltipManager } from '@app/utilities/map/features/tooltip';
import { PolygonManager } from '@app/utilities/map/features/polygon';
import { createMapSatelliteLayer } from '@app/utilities/map/ol/satellite-layer';
import { View } from 'ol';

@Injectable({
    providedIn: 'root',
})
export class MuckpileAnalyticsMapService {
    public map: Map | null = null;
    public tooltipManager: TooltipManager | null = null;
    public polygonManager: PolygonManager | null = null;
    private mapElementRef: HTMLElement | null = null;

    constructor(
        private fragQuery: FragQueryService,
    ) {}

    public initializeMap(center: geojson.Coord, mapElement: ElementRef) {
        this.mapElementRef = mapElement.nativeElement;
        this.initializeBaseSatelliteLayer(mapElement.nativeElement, center, 17);
        this.tooltipManager = new TooltipManager(this.map);
        this.polygonManager = new PolygonManager(this.map, this.tooltipManager);

        this.fragQuery.muckpile$.subscribe(muckpile => {
            const geometry = muckpile?.geometry;
            this.reCenterMap(geometry.coordinates[0][0], 17);
            if (this.polygonManager) {
                this.polygonManager.clearAll();
                this.polygonManager.add({
                    coordinates: geometry.coordinates,
                    content: muckpile.name,
                    color: muckpile.color
                })
            }
        })
    }

    public initializeBaseSatelliteLayer(
        mapElement: HTMLElement,
        center: geojson.Coord,
        zoom: number
    ) {
        // Initialize the OpenLayers map with Google Maps as the base layer
        this.map = new Map({
            target: mapElement,
            layers: [createMapSatelliteLayer()],
            view: new View({
                center: center,
                zoom: zoom
            }),
            controls: []
        });
        return this.map;
    }

    public reCenterMap(center: geojson.Coord, zoom?: number) {
        if (this.map) {
            const view = this.map.getView();
            view.setCenter(center);
            if (zoom !== undefined) {
                view.setZoom(zoom);
            }
        }
    }

    public cleanup() {
        if (this.map) {
            this.map.dispose();
            this.map = null;
        }
        this.tooltipManager = null;
        this.polygonManager = null;
        this.mapElementRef = null;
    }
}
